import {Component, OnDestroy} from '@angular/core';
import {BreadCrumbs, LogoAreaComponent} from '../logo-area/logo-area.component';
import {Organization, Query} from '../../types-repository';
import {HeadlineSectionComponent} from '../headline-section/headline-section.component';
import {Router, RouterModule, UrlSegment, UrlSegmentGroup} from '@angular/router';
import {OrgResolverPipe} from '../../pipes/org-resolver-pipe';

import {Apollo} from 'apollo-angular';
import {OAuthEvent, OAuthService} from 'angular-oauth2-oidc';
import {filter, map, startWith, take, tap} from 'rxjs/operators';
import {Subscription, switchMap} from 'rxjs';
import {GET_ORGANIZATIONS} from '../../queries-repository';

class DummyOAuthEvent extends OAuthEvent {
  constructor() {
    super('silently_refreshed');
  }
}

@Component({
  selector: 'app-organization-select',
  templateUrl: './organization-switcher.component.html',
  styleUrls: ['./organization-switcher.component.scss'],
  imports: [
    LogoAreaComponent,
    HeadlineSectionComponent,
    RouterModule,
    OrgResolverPipe
  ]
})
export class OrganizationSwitcherComponent implements OnDestroy {

  rest = []

  breadcrumbs: BreadCrumbs = [
    {
      commands: null,
      display: 'Content Platform'
    },
    {
      commands: null,
      display: 'My Organizations'
    }
  ]

  organizations: {
    org: Organization,
    url: any
  }[];
  loading = true;
  subscription: Subscription;

  /**
   * Closes the overlay outlet only, like the other two popovers: the primary outlet keeps whatever the
   * user was on, so this reveals that page rather than navigating away. On a fresh login there is no
   * page underneath yet, so the switcher comes straight back -- an organization still has to be picked.
   */
  protected dismiss(): void {
    this.router.navigate([{outlets: {overlay: null}}], {queryParamsHandling: 'preserve'});
  }

  constructor(apollo: Apollo, authService: OAuthService, private router: Router) {

    this.subscription = authService.events.pipe(
      startWith(new DummyOAuthEvent()),
      filter(() => authService.hasValidAccessToken()),
      take(1),
      tap(() => this.loading = true),
      switchMap(() => apollo.query<Query>({
        query: GET_ORGANIZATIONS
      }).pipe(
        map(res => res.data.organizations.organizations),
        map(orgs => [...orgs].sort((a, b) => a.name.localeCompare(b.name)))
      ))
    ).subscribe(orgs => {
        this.organizations = orgs.map(o => {
          const tree = this.router.parseUrl(this.router.url);
          const primary = tree.root.children['primary'];
          if (!primary ||
            (primary.segments[0].path !== 'o' || !primary.segments[1].path.startsWith('urn:janus:organization'))) {
            tree.root.children['primary'] = new UrlSegmentGroup([new UrlSegment('o', {}), new UrlSegment(o.id, {})], {})
            delete tree.root.children['overlay'];

            return {
              'org': o,
              'url': tree
            }

          } else {
            const segments = primary.segments.map(s => s.path);

            segments[1] = o.id;
            primary.segments = segments.map(s => new UrlSegment(s, {}));
            delete tree.root.children['overlay'];
            return {
              'org': o,
              'url': tree
            }
          }
        })
        this.loading = false;
      }
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }


}
